/* eslint-disable no-console */
import { withErrorBoundary } from "@sentry/nextjs";
import { useSearchParams } from "next/navigation";
import { FC, MouseEvent, useEffect, useState } from "react";
import { LinkButton } from "components/Atoms/LinkButton";
import { LinkButtonProps } from "components/Atoms/LinkButton/LinkButton";
import { isBlockedPrefetchHref } from "lib/utils/isBlockedPrefetchUrl";
import { parseLinkToEnv } from "lib/utils/parseLinkToEnv";

const GeneralRoutingLinkButton: FC<LinkButtonProps> = withErrorBoundary(({ children, href, onClick, ...props }) => {
  const [mounted, setMounted] = useState(false);
  const searchParams = useSearchParams();

  useEffect(() => {
    setMounted(true);
  }, []);

  const url = parseLinkToEnv(href);
  const isBlockedFromPrefetch = isBlockedPrefetchHref(href);

  // Convert searchParams to a string
  const paramsString = searchParams ? searchParams.toString() : "";
  const urlWithParams = paramsString ? `${url}?${paramsString}` : url;

  // Wait for href to match server-side render
  if (!mounted) {
    return null;
  }

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(e as MouseEvent<HTMLAnchorElement>);
    }
  };

  // Next.js auto-prefetches automatically based on viewport. The prefetch attribute is no longer needed. More: https://nextjs.org/docs/messages/prefetch-true-deprecated
  return (
    <LinkButton href={urlWithParams} onClick={handleClick} shouldPrefetch={!isBlockedFromPrefetch} {...props}>
      {children}
    </LinkButton>
  );
}, {});

export { GeneralRoutingLinkButton };
